import { render, staticRenderFns } from "./PositionsPage.vue?vue&type=template&id=58fdae37"
import script from "./PositionsPage.vue?vue&type=script&lang=js"
export * from "./PositionsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports